(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video"] && !Shopify.designMode) return;
  try {
    
(() => {
  function loadSwiperOnce () {
    if (window._ksSwiperLoader) return window._ksSwiperLoader;

    window._ksSwiperLoader = new Promise((resolve, reject) => {
      const onReady = () => {
        if (window.Swiper) {
          resolve();
        }
      };

      if (!document.querySelector('#swiper-stylesheet')) {
        const stylesheet = document.createElement('link');
        stylesheet.href = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css';
        stylesheet.rel = 'stylesheet';
        stylesheet.id = 'swiper-stylesheet';
        stylesheet.integrity = 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=';
        stylesheet.crossOrigin = 'anonymous';
        document.head.appendChild(stylesheet);
      }

      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js';
        script.id = 'swiper-script';
        script.integrity = 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=';
        script.crossOrigin = 'anonymous';
        script.onload = onReady;
        script.onerror = () => reject(new Error('Failed to load Swiper'));
        document.head.appendChild(script);
      } else {
        if (window.Swiper) {
          resolve();
          return;
        }

        const maxWait = 2000;
        const started = Date.now();

        const tick = () => {
          if (window.Swiper) {
            resolve();
            return;
          }

          if (Date.now() - started > maxWait) {
            reject(new Error('Swiper not available'));
            return;
          }

          requestAnimationFrame(tick);
        };

        tick();
      }
    });

    return window._ksSwiperLoader;
  }

  class KsShoppableVideos extends HTMLElement {
    constructor () {
      super();
      this._destroyed = false;
      this._swiper = null;
      this._observer = null;
    }

    connectedCallback () {
      loadSwiperOnce()
        .then(() => {
          if (this._destroyed) return;

          this.initSlider();
          this.bindVideoControls();
          this.setupAutoplayObserver();
        })
        .catch(() => {
          const root = this.querySelector('.swiper');
          if (root) root.classList.add('ks-fallback-visible');
        });
    }

    disconnectedCallback () {
      this._destroyed = true;

      if (this._swiper && this._swiper.destroy) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }

      if (this._observer && this._observer.disconnect) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    initSlider () {
      const root = this.querySelector('.swiper');
      if (!root || !window.Swiper) return;

      const options = this.buildOptions({
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
        paginationEl: this.querySelector('.swiper-pagination'),
        scrollbarEl: this.querySelector('.swiper-scrollbar')
      });

      try {
        this._swiper = new window.Swiper(root, options);

        this._swiper.on('slideChange', () => {
          root.classList.add('swiper-is-changing');
          this.onSlideChange();
        });

        this._swiper.on('slideChangeTransitionEnd', () => {
          root.classList.remove('swiper-is-changing');
        });
      } catch (e) {
        root.classList.add('ks-fallback-visible');
      }
    }

    buildOptions (els) {
      const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1;

      return {
        rewind: true,
        speed: Number(this.dataset.sliderSpeed) || 300,
        spaceBetween: Number(this.dataset.gap) || 0,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        breakpoints: {
          0: {
            slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile || 1
          },
          576: {
            slidesPerView: Number(this.dataset.breakpointSm) || 2
          },
          768: {
            slidesPerView: Number(this.dataset.breakpointMd) || 2
          },
          992: {
            slidesPerView: Number(this.dataset.breakpointLg) || 2
          },
          1200: {
            slidesPerView: Number(this.dataset.breakpointXl) || 3
          },
          1400: {
            slidesPerView: Number(this.dataset.breakpointXxl) || 4
          }
        },
        navigation: {
          enabled: this.dataset.sliderNav === 'true',
          nextEl: els.nextEl,
          prevEl: els.prevEl
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          type: this.dataset.sliderPaginationType || 'bullets',
          el: els.paginationEl,
          dynamicBullets: true,
          dynamicMainBullets: 2,
          renderFraction: (currentClass, totalClass) =>
            `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: els.scrollbarEl,
          draggable: true
        },
        autoplay: this.dataset.sliderAutoplay !== '0'
          ? {
              delay: Number(this.dataset.sliderAutoplay) * 1000
            }
          : undefined,
        watchSlidesProgress: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true
        }
      };
    }

    bindVideoControls () {
      this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach((btn) => {
        btn.addEventListener('click', () => {
          const video = btn.closest('.ks-shoppable-videos-video-wrapper')?.querySelector('video');
          if (video) this.onVideoPlay(video);
        });
      });

      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('click', () => this.onVideoPlay(video));
      });
    }

    setupAutoplayObserver () {
      if (!('IntersectionObserver' in window)) return;

      this._observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const video = entry.target;
          if (video && video.dataset.autoplay === 'true') {
            video.muted = true;
            video.play().catch(() => {});
          }
        });
      }, {
        rootMargin: '0px 0px 300px 0px'
      });

      this.querySelectorAll('video[data-autoplay="true"]').forEach((video) => {
        this._observer.observe(video);
      });
    }

    onSlideChange () {
      this.querySelectorAll('.ks-shoppable-videos-card').forEach((card) => {
        card.setAttribute('data-is-playing', 'false');
        card.querySelector('video')?.pause();
      });
    }

    onVideoPlay (video) {
      const card = video.closest('.ks-shoppable-videos-card');
      if (!card) return;

      this.querySelectorAll('.ks-shoppable-videos-card').forEach((item) => {
        if (item.dataset.index !== card.dataset.index) {
          item.setAttribute('data-is-playing', 'false');
          item.querySelector('video')?.pause();
        }
      });

      const isPlaying = card.dataset.isPlaying === 'true';

      card.setAttribute('data-is-playing', isPlaying ? 'false' : 'true');

      if (isPlaying) {
        video.pause();
      } else {
        video.muted = true;
        video.play().catch(() => {});
      }
    }
  }

  if (!customElements.get('ks-shoppable-videos')) {
    customElements.define('ks-shoppable-videos', KsShoppableVideos);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
